import React from 'react'
import { sizes } from './const'
import { lit } from 'src/utils'

export interface UserCircleIconProps {
    /**
     * This allows to pass a custom className to the component,
     * i.e. className="dark:fill-white", so that the icon is white in dark mode.
     *
     * Note: className overrides equivalent styles for size, stroke and fill.
     *
     * Color overriding seems to not work in Storybook.
     *
     */
    className?: string
    /**
     * The size we can use for the icon: small, medium, large.
     * small = 16px, medium = 24px, large = 32px.
     *
     * Will get overridden if a Tailwind width or height is passed into className
     *
     */
    size?: 'small' | 'medium' | 'large'
}

export const UserCircleIcon = (props: UserCircleIconProps) => {
    const { className = '', size = 'medium' } = props
    return (
        <svg
            className={lit`js_UserCircleIcon ${sizes[size]} ${className}`}
            fill="none"
            strokeWidth="1.5"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            stroke="black"
        >
            <path
                d="M4 12C5.4359 11.4074 6.35897 10.9136 6.76923 10.5185C7.38462 9.92593 5.53846 9.92593 5.53846 6.96296C5.53846 4.98765 6.35897 4 8 4C9.64103 4 10.4615 4.98765 10.4615 6.96296C10.4615 9.92593 8.61538 9.92593 9.23077 10.5185C9.64103 10.9136 10.5641 11.4074 12 12"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
